import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { AiAssistantI18nModule } from '../../assets/i18n/ai-assistant-i18n.module';
@Component({
  selector: 'ai-additional-instructions-dialog',
  imports: [CommonModule, MatDialogModule, MatButtonModule, AiAssistantI18nModule, GalaxyBadgeModule],
  templateUrl: './additional-instructions-dialog.component.html',
})
export class AdditionalInstructionsDialogComponent {}
